"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.login = exports.logIntoTenant = exports.logOut = exports.getUserAuth = exports.getCustomAuthProvider = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _urlSearchParams = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url-search-params"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/index-of"));

var _overrideSettings = require("../shared/override-settings/overrideSettings");

var getCustomAuthProvider = function getCustomAuthProvider() {
  var auth = (0, _overrideSettings.getOverrideSetting)('authImplementation');

  if (auth == null) {
    throw Error('Required override setting "authImplementation" not set');
  }

  return auth;
};

exports.getCustomAuthProvider = getCustomAuthProvider;
var WHITE_SPACE = ' ';

var getProfile = function getProfile(authUser) {
  var objectId = authUser.objectId,
      username = authUser.username,
      name = authUser.name,
      tenantId = authUser.tenantId;
  var givenName = '';
  var familyName = '';

  if (name) {
    var firstSpaceIndex = (0, _indexOf.default)(name).call(name, WHITE_SPACE);
    givenName = firstSpaceIndex !== -1 ? name.substring(0, firstSpaceIndex) : name;
    familyName = firstSpaceIndex !== -1 ? name.substring(firstSpaceIndex + 1) : '';
  }

  return {
    upn: username,
    oid: objectId,
    tid: tenantId,
    in_corp: '',
    name: name !== null && name !== void 0 ? name : '',
    given_name: givenName,
    family_name: familyName,
    amr: [],
    acrs: []
  };
};
/**
 * @deprecated Use `getCustomAuthProvider().user.value` instead.
 */


var getUserAuth = function getUserAuth() {
  var _authUser$username;

  var auth = getCustomAuthProvider();
  var authUser = auth.user();
  var oauthData = {
    isAuthenticated: authUser != null,
    userName: (_authUser$username = authUser === null || authUser === void 0 ? void 0 : authUser.username) !== null && _authUser$username !== void 0 ? _authUser$username : '',
    profile: authUser ? getProfile(authUser) : undefined
  };
  return oauthData;
};
/**
 * @deprecated Use `getCustomAuthProvider` to get the auth instance and
 * then call methods on that instance directly.
 */


exports.getUserAuth = getUserAuth;

var logOut = function logOut() {
  getCustomAuthProvider().logout();
};
/**
 * @deprecated Use `getCustomAuthProvider` to get the auth instance and
 * then call methods on that instance directly.
 */


exports.logOut = logOut;

var logIntoTenant = function logIntoTenant(tenantId) {
  getCustomAuthProvider().login({
    tenantId: tenantId
  });
};
/**
 * @deprecated Use `getCustomAuthProvider` to get the auth instance and
 * then call methods on that instance directly.
 */


exports.logIntoTenant = logIntoTenant;

var login = function login(extraQueryParameters) {
  var _auth$user;

  if (extraQueryParameters instanceof _urlSearchParams.default) {
    var obj = {};
    (0, _forEach.default)(extraQueryParameters).call(extraQueryParameters, function (value, key) {
      obj[key] = value;
    });
    extraQueryParameters = obj;
  }

  var auth = getCustomAuthProvider();
  var tenantId = (_auth$user = auth.user()) === null || _auth$user === void 0 ? void 0 : _auth$user.tenantId;
  tenantId && (auth === null || auth === void 0 ? void 0 : auth.login((0, _objectSpread2.default)({
    tenantId: tenantId
  }, extraQueryParameters)));
};

exports.login = login;